import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./scss/main.scss";
import "./scss/cv.scss";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
